import type { RootStore } from '~/stores/root.store';

export class YearInReviewController {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async fetchYearInReviewData() {
        const { yearInReviewService, yearInReviewStore, userStore } =
            this.rootStore;

        const yearInReviewData = await yearInReviewService.getYearInReviewData(
            userStore.currUser._id
        );

        const data = yearInReviewData?.data;

        if (data) {
            yearInReviewStore.load(yearInReviewData?.data);
        }
    }

    reset() {
        this.rootStore.yearInReviewStore.reset();
    }
}
